import { render } from "./MainView.vue?vue&type=template&id=33ed6886"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=33ed6886&lang=css"
script.render = render

export default script